import { Launch } from '@carbon/icons-react';
import { Menu } from 'antd';
import { MenuItemProps } from 'antd/lib/menu/MenuItem';
import React, { FC } from 'react';
import styled from 'styled-components';

const MenuItem = styled(Menu.Item)`
  a {
    display: flex;
    align-items: center;
    gap: var(--spacing-04);
    color: var(--primary-color);
  }
  span {
    flex: 1;
  }
`;

interface Props extends MenuItemProps {
  linkTo: string;
}

export const Link: FC<Props> = (params) => {
  const { icon = <Launch size={16} />, children, linkTo } = params;

  return (
    <MenuItem {...params}>
      <a href={linkTo} target="_blank" rel="noreferrer">
        {icon} {children}
      </a>
    </MenuItem>
  );
};
